import{createInstance as t}from"i18next";function r({locale:e,localeResource:a}){return t().init({lng:e,keySeparator:"$",interpolation:{escapeValue:!1},react:{wait:!0},resources:{[e]:{translation:a}}})}export{r as default};
//# sourceMappingURL=i18n.js.map
